import { LitElement as f, css as u, html as m } from "lit";
import { property as l } from "lit/decorators.js";
import { booleanType as a } from "../../../utils/property-types.js";
var b = Object.defineProperty, p = (d, e, r, o) => {
  for (var s = void 0, t = d.length - 1, i; t >= 0; t--)
    (i = d[t]) && (s = i(e, r, s) || s);
  return s && b(e, r, s), s;
};
class n extends f {
  constructor() {
    super(...arguments), this.deleted = !1, this.disabled = !1;
  }
  static get styles() {
    return [
      u`
        :host {
          display: flex;
          flex-direction: column;
          gap: var(--dss-spacing-xxs);
        }
      `
    ];
  }
  _propagateProperties() {
    var r;
    const e = (r = this.shadowRoot) == null ? void 0 : r.querySelectorAll("slot");
    e && e.forEach((o) => {
      o.assignedElements().forEach((t) => {
        this.deleted ? t.setAttribute("deleted", "true") : t.removeAttribute("deleted"), this.disabled ? t.setAttribute("disabled", "true") : t.removeAttribute("disabled");
      });
    });
  }
  /* LIT LIFECYCLE */
  updated(e) {
    super.updated(e), (e.has("deleted") || e.has("disabled")) && this._propagateProperties();
  }
  render() {
    return m` <slot></slot> `;
  }
}
p([
  l(a)
], n.prototype, "deleted");
p([
  l(a)
], n.prototype, "disabled");
export {
  n as CardBody
};
//# sourceMappingURL=card-body.js.map
